// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
String.prototype.hashCode = function () {
  var hash = 0,
      i,
      chr;
  if (this.length === 0) return hash;

  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};

String.prototype.contains = function (substr) {
  return this.indexOf(substr) > -1;
};

String.prototype.presence = function () {
  return this.length > 0 ? this.toString() : null;
};